import { render, staticRenderFns } from "./CardRadioRow.vue?vue&type=template&id=5b4bd424&scoped=true"
import script from "./CardRadioRow.vue?vue&type=script&lang=js"
export * from "./CardRadioRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bd424",
  null
  
)

export default component.exports